
import { BModal } from "bootstrap-vue"
import { Component, Inject, Prop, Vue } from "vue-property-decorator"

import CaseTimeline from "./CaseTimeline.vue"

import CaseAuditHistoryService from "@/services/caseAuditHistoryService"
import { CaseDetails } from "@/types"
import { Getter } from "vuex-class"

@Component({
	components: {
		"case-timeline": CaseTimeline
	}
})
export default class CaseTimelineModal extends Vue {
	@Inject() caseAuditHistoryService!: CaseAuditHistoryService

	$refs!: {
		caseTimelineModal: BModal;
	}

	@Prop({ type: Object, required: true }) currentCase!: CaseDetails

	@Prop({ type: Boolean, default: false }) canCreateComments!: boolean

	@Getter("getCaseName") caseName!: string;
	@Getter("getRecordName") recordName!: string;

	public get getCaseOrRecordName () {
		return this.currentCase?.isCase ? this.caseName : this.recordName
	}

	public async open (): Promise<void> {
		this.$refs.caseTimelineModal.show()
		await this.caseAuditHistoryService.refresh()
	}
}
